import { GAS_AIRDROP_CONFIG } from '../config/oft';
import { useInkGasBalance } from './useInkGasBalance';

/**
 * Returns true if the address's Ink ETH balance is below the gas airdrop threshold.
 *
 * A first-time Ink user with little or no ETH on Ink would need a small ETH airdrop
 * to pay for gas on the destination chain. The threshold is defined in GAS_AIRDROP_CONFIG.
 *
 * @param address - The address to check on Ink
 */
export function useNeedsGasAirdrop(address: `0x${string}` | undefined) {
  const { data: balanceData, isLoading, error } = useInkGasBalance(address);

  const needsAirdrop =
    balanceData !== undefined
      ? balanceData.raw < GAS_AIRDROP_CONFIG.gasThreshold
      : undefined;

  return {
    needsAirdrop,
    isLoading,
    error,
    inkBalance: balanceData,
  };
}
